import React from 'react';
import {Badge, Card, Divider} from 'antd-mobile';
import {useNavigate} from 'react-router-dom';
import {DeliveryDetailPath} from "../../../../enums/DeliveryNavigatePathEnum";
import {timestampToDate} from "../../../../utils/dateTimeUtils";
import {formatLocalizedDateTime} from "../../../../utils/dateFormatUtils";
import {t} from "../../../../i18n";

export interface DeliveredOrder {
    id: number,
    trackingNumber: string,
    address: string,
    routeNumber: string,
    deliveredAt: string,
    fullName: string;
}

interface OrderCardProps {
    order: DeliveredOrder,
}

const DeliveredCard: React.FC<OrderCardProps> = ({order}) => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate(DeliveryDetailPath.DELIVERY_DELIVERING_ORDER_DETAIL.replace(':trackingNumber', order.trackingNumber),{
            state:{
                deliveryTaskOrderId: order.id,
                trackingNumber: order.trackingNumber,
                detailType:'detail'
            }
        });
    };

    return (
        <Card className="my-2 rounded-lg" onClick={handleCardClick}>
            <div className="flex justify-between items-center">
                <div className="text-base font-medium break-all">{order.trackingNumber}</div>
            </div>
            <Divider/>
            <div className="flex gap-6">
                <div className="flex flex-col gap-1">
                    <h3 className="text-base font-semibold">{order.fullName}</h3>
                    <p>
                        {order.address}
                    </p>
                    <p>
                        {t('pages.delivery.delivered.route')} {order.routeNumber}
                    </p>
                    {order.deliveredAt && (
                        <p>
                            {t('pages.delivery.delivered.deliveredAt')} {formatLocalizedDateTime(timestampToDate(order.deliveredAt))}
                        </p>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default DeliveredCard;